import { connect } from 'react-redux'
import {
  mapProps,
  withHandlers,
  branch,
  renderNothing,
  compose
} from 'recompose'
import { DELETE_CONTACT_MODAL } from './constants'
import { isDeleteContactModalOpen, getModalContactId } from './selectors'
import { closeDeleteContactModal, deleteContact } from './actions'
import withTranslations from '../../../core/withTranslations'
import DeleteModal from '../../../ui/modal/delete-modal'

const translate = withTranslations({
  title: 'app:myCharity.charityAdmin.deleteContactModalTitle',
  subtitle: 'app:myCharity.charityAdmin.deleteModalSubtitle'
})

const mapStateToProps = state => ({
  isModalOpen: isDeleteContactModalOpen(state),
  contactId: getModalContactId(DELETE_CONTACT_MODAL, state)
})
const withModalStateAndActions = connect(mapStateToProps, {
  closeDeleteContactModal,
  deleteContact
})

const displayIfModalOpen = branch(props => !props.isModalOpen, renderNothing)

const withButtonHandlers = withHandlers({
  onCancel: props => e => {
    e.preventDefault()
    props.closeDeleteContactModal()
  },
  onAccept: props => e => {
    e.preventDefault()
    props.deleteContact(props.contactId).then(props.closeDeleteContactModal())
  }
})

const renameProps = mapProps(props => {
  const { title, subtitle, onAccept, onCancel } = props
  return {
    title,
    subtitle,
    onAccept,
    onCancel
  }
})

export const decorate = compose(
  translate,
  withModalStateAndActions,
  displayIfModalOpen,
  withButtonHandlers,
  renameProps
)

export default decorate(DeleteModal)



// WEBPACK FOOTER //
// ./src/services/mycharity/charity/DeleteContactModal.js